import React, {Component} from 'react';
import {uniqueId} from 'lodash';
import {Button, Col, Row} from "reactstrap";
import assets from "../../../util/assets";
import "./index.css";
import "../common.css";
import {vuePayLog} from "../../../util/utility";
import ChangeBroadcast from "../../broadcast/ChangeBroadcast";

export default class ChangeBroadcastComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {};
    }

    componentDidMount() {

    }

    render() {

        return (
            <div className="chat-component-container">
                <Row className="chat-component-header-container">
                    <Col className="chat-component-header">Change Broadcast</Col>
                    <Col className="chat-component-header-close">
                        <img src={assets.broadcast.cross}
                             onClick={() => {
                                 vuePayLog("ChangeBroadcastComponent", "", "Cross icon clicked");
                                 this.props.setRightLayout("");
                             }}
                             alt="cross icon"
                             width={13}/>
                    </Col>
                </Row>
                <div className="chat-component-header-divider "/>
                <Row className="mx-0">
                    <Col sm="12" className="px-0 full-width">
                        <Row className="mx-0">
                            <div className="full-width change-broadcast-item no-margin no-padding">
                                <ChangeBroadcast
                                    isBroadcasterVerified={this.props.isBroadcasterVerified}
                                    initialValues={this.props.initialValues}
                                    createBroadcast={this.props.createBroadcast}
                                    disconnectFromTokBoxAndChangeBroadcast={
                                        this.props.disconnectFromTokBoxAndChangeBroadcast
                                    }
                                />
                            </div>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}


